import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { Stat } from '../../model/stat';
import { NavParams } from 'ionic-angular';

@Component({
    selector: 'page-stats-more',
    templateUrl: 'stats-more.html'
})
export class StatsMorePage {
    stat: Stat;

    constructor(navParams: NavParams, private nav: NavController) {
        this.stat = navParams.get('stat');
    }

    back() {
        this.nav.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/stats/stats-more.ts